module.exports = __webpack_public_path__ + "img/6-4.55c0a4d9.jpg";